import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';


import {AppComponent} from './app.component';
import {RouterModule} from '@angular/router';
import {ROUTES} from './app.routes';
import {MenuModule} from './components/menu/menu.module';
import {HomepageModule} from './components/homepage/homepage.module';
import {FooterModule} from './components/footer/footer.module';
import {MobileApplicationDevModule} from './components/mobile-application-dev/mobile-application-dev.module';
import {FintechSolutionsModule} from './components/fintech-solutions/fintech-solutions.module';
import {GamingPlatformModule} from './components/gaming-platform/gaming-platform.module';
import {ContactUsModule} from './components/contact-us/contact-us.module';
import {FaqModule} from './components/faq/faq.module';
import {OnlineCasinoSolutionModule} from './components/online-casino-solution/online-casino-solution.module';
import {TopGamesModule} from './components/top-games/top-games.module';
import {IncorporationModule} from './components/incorporation/incorporation.module';
import {PaymentIntegrationModule} from './components/payment-integration/payment-integration.module';
import {HostingModule} from './components/hosting/hosting.module';
import {CasinoPromotionModule} from './components/casino-promotion/casino-promotion.module';
import {PrivacyPolicyModule} from './components/privacy-policy/privacy-policy.module';
import {HttpClientModule} from '@angular/common/http';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(ROUTES),
    MenuModule,
    HttpClientModule,
    HomepageModule,
    MobileApplicationDevModule,
    FintechSolutionsModule,
    GamingPlatformModule,
    ContactUsModule,
    FaqModule,
    OnlineCasinoSolutionModule,
    TopGamesModule,
    IncorporationModule,
    PaymentIntegrationModule,
    HostingModule,
    CasinoPromotionModule,
    FooterModule,
    PrivacyPolicyModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts